import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// data-controller="tom-select"
export default class extends Controller {
  connect() {
    this.initIconSelects()
    this.initTagSelects()
    this.initDefaultSelects()
  }

  initIconSelects() {
    this.element.querySelectorAll('.tom-select-icons').forEach((el) => {
      if (el.tomselect) return

      new TomSelect(el, {
        sortField: { field: "text", direction: "asc" },
        plugins: ['clear_button'],
        onItemAdd() {
          this.setTextboxValue('')
          this.refreshOptions()
        },
        render: {
          item: (data, escape) => `
            <div>
              <i class="${escape(data.value)} me-2"></i>${escape(data.value)}
            </div>
          `,
          option: (data, escape) => `
            <div>
              <i class="${escape(data.value)} me-2"></i>${escape(data.value)}
            </div>
          `,
          no_results: this.getNoResultsRenderer()
        }
      })
    })
  }

  initTagSelects() {
    this.element.querySelectorAll('.tom-select-tags').forEach((el) => {
      if (el.tomselect) return

      new TomSelect(el, {
        plugins: ['remove_button'],
        create: true,
        onItemAdd() {
          this.setTextboxValue('')
          this.refreshOptions()
        },
        render: {
          no_results: this.getNoResultsRenderer()
        }
      })
    })
  }

  initDefaultSelects() {
    const elements = this.element.tagName == "SELECT"
      ? [this.element]
      : this.element.querySelectorAll('.tom-select')

    elements.forEach((el) => {
      if (el.tomselect) return

      const isMultiple = el.multiple

      let settings = {
        itemClass: `item ${el.dataset.itemClass}`,
        plugins: isMultiple
          ? { remove_button: { title: 'Remover' } }
          : { clear_button: { title: 'Limpar' } },
        render: {
          no_results: this.getNoResultsRenderer()
        }
      }

      new TomSelect(el, settings)
    })
  }

  getNoResultsRenderer() {
    return function (data, escape) {
      const input = data.input.toLowerCase()

      const hasOptions = Object.values(this.options).some(option =>
        option.text.toLowerCase().includes(input)
      )

      if (!hasOptions && this.settings.create) {
        return ''
      }

      return `<div class="no-results">Não encontrado</div>`
    }
  }

  // 🔥 create remoto reutilizável
  createRemoteOption(el, input, callback) {
    if (!input.trim()) return

    fetch(el.dataset.createUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
        "Accept": "application/json"
      },
      body: JSON.stringify({
        name: input
      })
    })
      .then(res => {
        if (!res.ok) throw new Error()
        return res.json()
      })
      .then(data => {
        callback({
          value: data.id,
          text: data.name
        })
      })
      .catch(() => callback())
  }
}